export interface LeaderboardScreenPlayerInfoConfig
{
  is_player: boolean;
  is_near_player?: boolean;
  name: string;
  level: number;
  rating: number;
  avatar_id: number;
  facebook_av_url?: string | null;
  score: number;
  country_code: string;
  user_id?: string;
  days_in_game?: number | null;
}

export const DEFAULT_LEADERBOARD_SCREEN_PLAYER_INFO_CONFIG: LeaderboardScreenPlayerInfoConfig = {
  is_player: true,
  is_near_player: false,
  name: "Player Name",
  level: 1,
  rating: 17,
  avatar_id: 0,
  score: 10000,
  country_code: "US",
};
